import {
    GET_DATA_LIST_SUCCESS,
    GET_DATA_LIST_FAILURE
} from './action';
const initialState = {
    dataListSuccess: [],
    dataListFailure:[]
}

const dataListReducer = (state=initialState, action) => {
    switch(action.type) {
        case GET_DATA_LIST_SUCCESS:
            return  state = {
                ...state,
                dataListSuccess: action
            }
        case GET_DATA_LIST_FAILURE:
            return  state = {
                ...state,
                dataListFailure: action
            }
        default: return state
    }
}
export default dataListReducer;
